module.exports = __webpack_public_path__ + "media/pl_pl_s3_Halinka.cca22f51.oga";